import { render } from "./DashboardRowView.vue?vue&type=template&id=4ddb63b4"
import script from "./DashboardRowView.vue?vue&type=script&lang=js"
export * from "./DashboardRowView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__